document.addEventListener('DOMContentLoaded', function () {
	var openTriggers = document.querySelectorAll('[data-special-events-open]');
	var modals = document.querySelectorAll('[data-special-events-modal]');
	var activeModal = null;
	var lastFocusedTrigger = null;

	// Move each modal to the end of <body>. If an ancestor in the page
	// has a transform, filter, perspective, contain, or will-change
	// property set, position:fixed children anchor to that ancestor
	// instead of the viewport — which is what was causing the modal
	// to track scroll position instead of staying centered on screen.
	modals.forEach(function (modal) {
		document.body.appendChild(modal);
	});

	function openModal(modal, trigger) {
		if (!modal) return;
		activeModal = modal;
		lastFocusedTrigger = trigger || null;
		modal.classList.add('is-open');
		modal.setAttribute('aria-hidden', 'false');
		document.body.classList.add('special-events-modal-open');

		var closeBtn = modal.querySelector('[data-special-events-close]');
		if (closeBtn && closeBtn.tagName === 'BUTTON') {
			closeBtn.focus();
		}
	}

	function closeModal(modal) {
		if (!modal) return;
		modal.classList.remove('is-open');
		modal.setAttribute('aria-hidden', 'true');
		document.body.classList.remove('special-events-modal-open');
		activeModal = null;

		if (lastFocusedTrigger) {
			lastFocusedTrigger.focus();
			lastFocusedTrigger = null;
		}
	}

	openTriggers.forEach(function (trigger) {
		trigger.addEventListener('click', function () {
			var targetId = trigger.getAttribute('data-target');
			var modal = document.getElementById(targetId);
			openModal(modal, trigger);
		});
	});

	modals.forEach(function (modal) {
		var closers = modal.querySelectorAll('[data-special-events-close]');
		closers.forEach(function (closer) {
			closer.addEventListener('click', function () {
				closeModal(modal);
			});
		});
	});

	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape' && activeModal) {
			closeModal(activeModal);
		}
	});
});